import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { InsuranceService } from 'src/app/services/insurance.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-insurance-certificates-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './insurance-certificates-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InsuranceCertificatesGridComponent extends BaseGridComponent {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private InsuranceService: InsuranceService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'InsuranceCertificate';
    this.rowModelType = 'serverSide';

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.InsuranceService.getInsuranceCertificates(queryObject),
          this.InsuranceService.getInsuranceCertificateCount(countQueryObject)
        ]).subscribe({
          next: ([InsuranceCertificates, InsuranceCertificateCount]) => {
            params.success({
              rowData: InsuranceCertificates,
              rowCount: InsuranceCertificateCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
